<template>
  <div class="AddTag addCommon" style="height: 100%">
    <div class="return">
      <i class="el-icon-back" @click="goReturn">{{$t('LanguageLib.Return')}}</i>
      <span class="border"></span>
      <span class="title">{{ titleType }}</span>
    </div>
    <div class="content">
      <el-button @click="submit()" type="primary" class="searchBtn" :loading="loadingSave1">{{$t('LanguageLib.SAVE')}}</el-button>
      <p class="tagging">{{$t('LanguageLib.Note_WXSYNCHROHIZATION_LABEL')}}</p>
      <div class="tagContent">
        <div class="allTag">
          <h4>{{$t('LanguageLib.ALL_TAGS')}}</h4>
          <ul>
            <li :class="{'active' : item.checked}" v-for="item in tagList" :key="item.id" @click="checkTag(item)" :style="{cursor : item.isDelete ? 'not-allowed' : 'pointer'}" :title="item.tagName"><span class="tagName">{{item.tagName}}</span><i v-if="item.wxUserTagId">*</i></li>
          </ul>
        </div>
        <div class="checkedTag">
          <h4>
            <span v-if="tagType == '0'" class="storeName">{{$t('LanguageLib.NOTE_CURRENTLY_SELECTED')}}{{StoreIdList.length}}{{$t('LanguageLib.SHOP_PAGE_ONLY_SHOW_AND_MAINTAIN_COMMON_TAGS')}}</span>
            <span v-if="tagType == '1'" class="storeName" v-html="$commonfun.RenderWxName('departmentName', storeName)"></span>
            <el-button @click="createTag()" type="primary" class="searchBtn" style="float: right;margin-bottom: 0;">{{$t('LanguageLib.NEW_LABEL')}}</el-button>
          </h4>
          <ul>
            <li v-for="item in checkTagList" :key="item.id" class="active" :title="item.tagName"><span class="tagName">{{item.tagName}}</span><i v-if="item.wxUserTagId">*</i><i class="el-icon-close" style="margin-left: 10px;" @click="removeTag(item)" v-if="!item.isQYBinding"></i></li>
          </ul>
        </div>
      </div>
      <el-dialog :title="$t('LanguageLib.ADD_NEW_LABEL')" :visible.sync="dialogcreateTag" class="createTagDialog dialogAdd" :before-close="closeDialog" :close-on-click-modal="false">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item :label="$t('LanguageLib.LABEL_NAME')" prop="TagName">
            <el-input autocomplete="off" :placeholder="$t('LanguageLib.PleaseEnter')" v-model="ruleForm.TagName" maxlength="50"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitTag('ruleForm')" :loading="loadingSave2">{{$t('LanguageLib.DETERMINE')}}</el-button>
        </div>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import storeinformationApi from '../../api/storeinformation'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
export default {
  name: 'AddStore',
  props: ['currentPage', 'pageSize', 'parentId', 'searchText', 'sort', 'sortOrder', 'checkedStoreTypeData', 'checkedModeOperationData', 'checkedBrandData', 'orgName', 'type', 'sortNumber', 'orgTypeid', 'remark'],
  data () {
    var checkStoreName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('LanguageLib.LABEL_NAME') + ' ' + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        if (this.$commonfun.isNull(value)) {
          return callback(new Error(this.$t('LanguageLib.LABEL_NAME') + ' ' + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
        } else {
          callback()
        }
      }
    }
    return {
      tagType: this.$route.query.tagType, // 判断是单个店铺标签还是批量添加标签
      storeName: this.$route.query.storeName, // 店铺名称
      titleType: this.$t('LanguageLib.SET_LABEL'),
      tagList: [], // 所有标签列表
      checkTagList: [], // 已选中的标签列表
      dialogcreateTag: false, // 是否显示新增附件弹框
      StoreIdList: [], // 店铺id list
      ruleForm: {
        TagName: '' // 标签名称
      },
      rules: {
        TagName: [{
          validator: checkStoreName,
          trigger: 'blur'
        }]
      },
      loadingSave1: false, // 保存按钮加loding
      loadingSave2: false // 确认按钮加loding
    }
  },
  beforeRouteEnter (to, from, next) {
    NProgress.configure({
      easing: 'ease',
      speed: 500,
      showSpinner: false,
      trickleSpeed: 200,
      minimum: 0.3
    })
    NProgress.start()
    // 获取公司店铺标签列表
    storeinformationApi.storeTagList('get', '/tag/storeTagList', {
      pageIndex: 1,
      pageSize: 2147483647
    })
      .then(value => {
        NProgress.done()
        next(vm => {
          vm.StoreIdList = to.query.StoreIdList.split(',')
          vm.tagList = value.data
          for (let i = 0; i < vm.tagList.length; i++) {
            vm.tagList[i].checked = false // checked 标签是否被选中的字段
            vm.tagList[i].isDelete = false // isDelete 标签是否可以被取消选中
          }
          // 获取店铺关联标签
          storeinformationApi.MultiStoreTagRelation('post', '/tag/MultiStoreTagRelation', vm.StoreIdList)
            .then(value => {
              vm.checkTagList = value.data
              for (let i = 0; i < vm.tagList.length; i++) {
                for (let j = 0; j < vm.checkTagList.length; j++) {
                  if (vm.tagList[i].id === vm.checkTagList[j].id) {
                    vm.tagList[i].checked = true // 判断是否选中
                    vm.checkTagList[j].wxUserTagId = vm.tagList[i].wxUserTagId // 判断是否企微关联
                    if (vm.checkTagList[j].isQYBinding) {
                      vm.tagList[i].isDelete = true // 判断是否允许取消
                    }
                  }
                }
              }
            })
            .catch(err => {
              this.$commonfun.console.log(err)
            })
        })
      })
      .catch(err => {
        this.$commonfun.console.log(err)
      })
  },
  created () {
  },
  methods: {
    // 返回
    goReturn () {
      this.$router.push('/storeinformation/storemanagement?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&checkDomainId=' + this.$route.query.checkDomainId + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&sort=' + this.$route.query.sort + '&sortOrder=' + this.$route.query.sortOrder + '&checkedStoreTypeData=' + this.$route.query.checkedStoreTypeData + '&checkedModeOperationData=' + this.$route.query.checkedModeOperationData + '&checkedBrandData=' + this.$route.query.checkedBrandData + '&fromPath=addstore')
    },
    // 添加新标签
    createTag () {
      this.ruleForm.TagName = ''
      this.dialogcreateTag = true
    },
    // 选中标签
    checkTag (obj) {
      if (obj.isDelete) {
        return false
      }
      if (obj.checked) {
        for (let i = this.checkTagList.length - 1; i >= 0; i--) {
          if (obj.tagName === this.checkTagList[i].tagName) {
            this.checkTagList.splice(i, 1)
          }
        }
      } else {
        this.checkTagList.push(obj)
      }
      obj.checked = !obj.checked
    },
    // 移出选中标签
    removeTag (obj) {
      for (let i = this.checkTagList.length - 1; i >= 0; i--) {
        if (obj.tagName === this.checkTagList[i].tagName) {
          this.checkTagList.splice(i, 1)
        }
      }
      for (let j = 0; j < this.tagList.length; j++) {
        if (obj.tagName === this.tagList[j].tagName) {
          this.tagList[j].checked = false
        }
      }
    },
    // 保存标签
    submitTag (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadingSave2 = true
          storeinformationApi.CreateStoreTag('post', '/tag/CreateStoreTag', this.ruleForm)
            .then(res => {
              this.loadingSave2 = false
              this.dialogcreateTag = false
              var a = 0
              this.tagList.forEach(item => {
                if (item.tagName === this.ruleForm.TagName) {
                  a = 1
                }
              })
              if (a === 0) {
                this.$message({
                  type: 'success',
                  message: this.$t('LanguageLib.ADDED_SUCCESSFULLY1')
                })
                this.tagList.push({
                  addUserId: res.data.addUserId,
                  ownerId: res.data.ownerId,
                  checked: true,
                  wxUserTagId: res.data.wxUserTagId,
                  id: res.data.id,
                  isDelete: false,
                  tagName: res.data.tagName
                })
                this.checkTagList.push({
                  addUserId: res.data.addUserId,
                  ownerId: res.data.ownerId,
                  checked: true,
                  wxUserTagId: res.data.wxUserTagId,
                  id: res.data.id,
                  isDelete: false,
                  tagName: res.data.tagName
                })
              }
            })
            .catch(err => {
              this.loadingSave2 = false
              this.$commonfun.console.log(err)
            })
        } else {
          return false
        }
      })
    },
    // 关闭对话框  清除校验
    closeDialog () {
      this.dialogcreateTag = false
      this.$refs.ruleForm.clearValidate()
    },
    // 批量保存店铺标签关联
    submit () {
      this.loadingSave1 = true
      const TagIdList = []
      this.checkTagList.forEach((item, index) => {
        TagIdList.push(item.id)
      })
      storeinformationApi.SaveRelationBatch('post', '/tag/SaveRelationBatch', {
        StoreIdList: this.StoreIdList,
        TagIdList: TagIdList
      })
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('LanguageLib.ADDED_SUCCESSFULLY1')
          })
          this.$router.push('/storeinformation/storemanagement?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&checkDomainId=' + this.$route.query.checkDomainId + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&sort=' + this.$route.query.sort + '&sortOrder=' + this.$route.query.sortOrder + '&checkedStoreTypeData=' + this.$route.query.checkedStoreTypeData + '&checkedModeOperationData=' + this.$route.query.checkedModeOperationData + '&checkedBrandData=' + this.$route.query.checkedBrandData + '&fromPath=addstore')
          this.loadingSave1 = false
        })
        .catch(err => {
          this.loadingSave1 = false
          this.$commonfun.console.log(err)
        })
    }
  }
}
</script>

<style lang="scss">
  .AddTag {
    .TeInput input {
      border-right: 0px;
      border-radius: 4px 0 0 4px;
    }
    .return {
      padding-left: 25px;
      position: relative;
      height: 50px;
      background: rgba(255, 255, 255, 1);
      line-height: 50px;
      border-bottom: 1px solid #F2F2F2;
      .el-icon-back {
        margin-right: 15px;
        cursor: pointer;
      }
      .border {
        position: absolute;
        height: 37px;
        border-left: 1px solid #f1f1f1;
        display: inline-block;
        top: 5px;
      }
      .title {
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        margin-left: 15px;
      }
    }
    .content::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    .content::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      background: #E1E1E1;
    }
    .content::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      border-radius: 5px;
      background: #fff;
    }
    .content {
      background: rgba(255, 255, 255, 1);
      width: 100%;
      height: calc( 100% - 66px);
      overflow-y: auto;
      padding: 0 100px 20px 100px;
      padding-top: 15px;
      box-sizing: border-box;
      .tagging{
        color: #999999;
        font-size: 14px;
      }
      .tagContent {
        height: 776px;
        width: 100%;
        margin-top: 16px;
        .allTag,
        .checkedTag {
          width: calc(50% - 9px);
          height: 100%;
          float: left;
          h4{
            width: calc(100% - 40px);
            height: 50px;
            background: #F2F2F2;
            padding: 0 20px;
            font-size: 14px;
            color: #4D4D4D;
            display: flex;
            align-items: center;
            border: none;
            .storeName{
              width: 100%;
              overflow: hidden;
              display: block;
              float: left;
              padding-right: 15px;
            }
          }
          ul{
            border:1px solid rgba(225,225,225,1);
            width: calc(100% - 42px);
            height: calc(100% - 84px);
            padding: 16px 20px;
            li{
              padding: 5px 16px;
              background:rgba(204,204,204,0.15);
              border:1px solid #C9C9C9;
              float: left;
              margin-right: 10px;
              margin-bottom: 10px;
              cursor: pointer;
              border-radius: 2px;
              i{
                font-style: normal;
              }
              .tagName{
                max-width: 130px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                display: block;
                float: left;
              }
            }
            li.active{
              background:rgba(59,198,185,0.15);
              border:1px solid rgba(59,198,185,1);
              color: #3BC6B9;
            }
          }
        }
        .checkedTag {
          margin-left: 18px;
        }
      }
      .drawerText {
        margin-bottom: 5px;
        height: 16px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(77, 77, 77, 1);
        line-height: 16px;
      }
      h4 {
        font-size: 14px;
        color: #999999;
        font-weight: normal;
        padding-bottom: 9px;
        border-bottom: 1px solid #D8DCE6;
      }
      .contentTop,
      .infoForm {
        padding: 15px 0 0 26px;
        .parent {
          width: 50%;
          display: inline-block;
        }
      }
    }
     /*修改按钮样式*/
    .el-button--primary {
      background-color: #3BC6B9;
      border-color: #3BC6B9;
      height: 30px;
      padding: 7px 20px;
      margin-bottom: 15px;
    }
    .colorRed {
      color: red;
    }
     /*组织树视图*/
    .el-dialog {
      overflow: hidden;
      .left {
        background: #fff;
        width: 320px;
        height: 535px;
        border: 1px solid #f2f2f2;
        .fifter {
          height: 30px;
          padding: 10px 0 10px 20px;
          margin: 0 auto;
          border-bottom: 1px solid #f2f2f2;
          .el-input {
            width: 220px;
            input {
              height: 30px;
              line-height: 30px;
              border-radius: 20px;
            }
            .el-icon-search {
              line-height: 30px;
            }
          }
          .el-button--text {
            margin-left: 8px;
            padding: 7px 0;
            color: #3BC6B9;
          }
        }
        .treeBox {
          height: calc( 100% - 51px);
          overflow: auto;
          width: 320px;
        }
        .treeBox::-webkit-scrollbar {
          width: 10px;
          height: 10px;
        }
        .treeBox::-webkit-scrollbar-thumb {
          border-radius: 5px;
          -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
          background: #E1E1E1;
        }
        .treeBox::-webkit-scrollbar-track {
          -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
          border-radius: 5px;
          background: #fff;
        }
      }
    }
    .el-textarea__inner {
      font: 400 13.3333px Arial;
    }
    .el-button--primary{
      margin-left: 0;
    }
  }
.el-range-editor.el-input__inner{
  width: 320px;
}
.createTagDialog{
  .el-dialog{
    width: 420px !important;
  }
}
</style>
